import React from "react";
import { RouteObject } from "react-router-dom";
import { LoggedInProps } from "modules/common/components/routing/AnonymousRoute";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import { SessionType } from "modules/session/auth/models/session";
import { OrderConfirmStoreType } from "./models/store";
import { OrderConfirmsPage } from "./components/OrderConfirmsPage";

export const buildRoutes = ({ store, session, loggedIn }: RoutesProps): RouteObject[] => [
  {
    path: `${routes.orders.orderConfirmsTab}/*`,
    element: (
      <ProtectedRoute loggedIn={loggedIn}>
        <OrderConfirmsPage store={store} session={session} />
      </ProtectedRoute>
    ),
  },
];

interface RoutesProps extends LoggedInProps {
  store: OrderConfirmStoreType;
  session: SessionType;
}
